"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _AppConstants = _interopRequireDefault(require("../../../../../constants/AppConstants"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../../util/ServiceRegistry"));
var _CallbackTypes = _interopRequireDefault(require("../../../../../constants/CallbackTypes"));
var _saveFile = _interopRequireDefault(require("../../../../actions/saveFile"));
require("!style-loader!css-loader!./SaveActionView.css");
var _class;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Component for Save action button in the header
 */
let SaveActionView = (0, _mobxReact.observer)(_class = class SaveActionView extends _react.Component {
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    let enableSaveButton = false;
    let showSaveButton = false;
    const previewConfig = appStore.getActionConfig("preview");
    if (!appStore.configStore.isThumbnailView) {
      const isDirty = appStore.isDirty;
      const saveInProgress = appStore.fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVING;
      const isEditAllowed = appStore.isInPreview && appStore.isEditAllowed && (previewConfig.showAnnotationTools || previewConfig.enableFormFilling);
      enableSaveButton = isDirty && !saveInProgress;
      showSaveButton = isEditAllowed;
    }
    const saveCallbackConfig = appStore.configStore.getSaveCallbackConfig();
    if (appStore.enableModernViewer) {
      if (saveCallbackConfig.autoSaveFrequency > 0) {
        // auto-save is enabled, hiding save button by default
        showSaveButton = false;
      } else {
        showSaveButton = saveCallbackConfig.showSaveButton;
      }
    } else if (saveCallbackConfig.showSaveButton === false) {
      showSaveButton = false;
    }
    const hideDisabledSaveButton = !enableSaveButton && !appStore.getActionConfig("preview").showDisabledSaveButton;
    let saveButtonLabel = "button.save";
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    if (!callbackService.hasCallback(_CallbackTypes.default.SAVE_API) && appStore.enableModernViewer) {
      saveButtonLabel = "download";
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showSaveButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "primary",
      onClick: () => (0, _saveFile.default)().catch(() => {}),
      className: (0, _classnames.default)([hideDisabledSaveButton ? "sdk-SaveActionView-displayNone" : "", ...(this.props.classNames || ["sdk-SaveActionView-save"])]),
      disabled: !enableSaveButton
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: saveButtonLabel
    })));
  }
}) || _class;
SaveActionView.propTypes = {
  classNames: _propTypes.default.arrayOf(_propTypes.default.string)
};
SaveActionView.defaultProps = {
  classNames: undefined
};
var _default = exports.default = SaveActionView;